import * as types from "../types";
import * as _api from "../../api";
import { call, put, takeLatest } from "redux-saga/effects";
import { clearErrors, returnErrors } from "../actions/errorAction";
import { createAuctionFailure, createAuctionSuccess } from "../actions/createAuctionAction";


function* asyncCreateAuctionRequestSaga(action){

    try{
    yield put(clearErrors());
    let createAuctionResult = yield call(_api.createAuctionRequestApi,{
        accessToken: action.payload.accessToken,
        auction_name: action.payload.auction_name,
        start_date: action.payload.start_date,
        end_date: action.payload.end_date,
        file: action.payload.file,
        auction_group:action.payload.auction_group,
    })
     yield put(createAuctionSuccess({createAuctionResult}));
    }catch(e){
        yield put(createAuctionFailure({error:e}));
        yield put(returnErrors({msg:e.message, status: true}))
    }
}

export default function* createAuctionRequestSaga(){
    yield takeLatest(types.CREATE_AUCTION_REQUEST,asyncCreateAuctionRequestSaga)
}